import type { Handler, NextFn } from '@warp-drive/core/request';
import type {
  ImmutableRequestInfo,
  RequestContext,
  StructuredDataDocument,
} from '@warp-drive/core/types/request';

import { normalizeWithLegacySerializer } from 'umg-ember-backend/data/normalizers/legacy-rest';

type UmgRestPayload = Record<string, unknown>;

const RestHandler: Handler = {
  async request<T>(
    context: RequestContext,
    next: NextFn<T>,
  ): Promise<T | StructuredDataDocument<T>> {
    const document = await next(context.request);
    const recordType = recordTypeForRequest(context.request);

    if (!recordType) {
      return document;
    }

    const { store } = context.request;

    if (!store) {
      throw new Error(
        'RestHandler requires UMG REST requests to be made through store.request().',
      );
    }

    return {
      ...document,
      content: normalizeWithLegacySerializer(
        store,
        document.content as UmgRestPayload,
        recordType,
        context.request,
      ) as T,
    };
  },
};

export default RestHandler;

function recordTypeForRequest(request: ImmutableRequestInfo): string | null {
  const optionRecordType = request.options?.recordType;

  if (typeof optionRecordType === 'string') {
    return optionRecordType;
  }

  const recordType = request.records?.[0]?.type;

  if (typeof recordType === 'string') {
    return recordType;
  }

  return null;
}
